import gql from 'graphql-tag'

export const CreateComment = gql`
    mutation CreateComment($data: CommentCreateInput!) {
        createComment(data: $data) {
            __typename
            id
            ancestorCommentIds
            comments {
                id
            }
            content
            author {
                id
            }
            createdAt
            updatedAt
            parentConversation {
                id
            }
            parentComment {
                id
            }
        }
    }
`

// mutation UpsertParentAndCreateConversation($parentId: String!, $parent: ParentCreateInput!) {
// 	upsertParent(where: { parent: $parentId }, create: $parent, update: { parent: $parentId }) {

export const UpdateComment = gql`
    mutation UpdateComment($content: String!, $commentId: ID!) {
        updateComment(data: { content: $content }, where: { id: $commentId }) {
            id
            content
        }
    }
`

export const AddUserToCommentBookmarkedByList = gql`
    mutation AddUserToCommentBookmarkedByList(
        $commentId: ID!
        $oauthId: String!
    ) {
        updateComment(
            where: { id: $commentId }
            data: { bookmarkedBy: { connect: { oauthId: $oauthId } } }
        ) {
            id
            content
            bookmarkedBy {
                id
                oauthId
                display
            }
        }
    }
`

export const RemoveUserFromCommentBookmarkedByList = gql`
    mutation RemoveUserFromCommentBookmarkedByList(
        $commentId: ID!
        $oauthId: String!
    ) {
        updateComment(
            where: { id: $commentId }
            data: { bookmarkedBy: { disconnect: { oauthId: $oauthId } } }
        ) {
            id
            content
            bookmarkedBy {
                id
                oauthId
                display
            }
        }
    }
`

export const AddUserToConversationBookmarkedByList = gql`
    mutation AddUserToConversationBookmarkedByList(
        $conversationId: ID!
        $oauthId: String!
    ) {
        updateConversation(
            where: { id: $conversationId }
            data: { bookmarkedBy: { connect: { oauthId: $oauthId } } }
        ) {
            id
            bookmarkedBy {
                id
                oauthId
                display
            }
        }
    }
`

export const RemoveUserFromConversationBookmarkedByList = gql`
    mutation RemoveUserFromConversationBookmarkedByList(
        $conversationId: ID!
        $oauthId: String!
    ) {
        updateConversation(
            where: { id: $conversationId }
            data: { bookmarkedBy: { disconnect: { oauthId: $oauthId } } }
        ) {
            id
            bookmarkedBy {
                id
                oauthId
                display
            }
        }
    }
`

export const AddUserToLikedByList = gql`
    mutation AddUserToLikedByList($commentId: ID!, $oauthId: String!) {
        updateComment(
            where: { id: $commentId }
            data: { likedBy: { connect: { oauthId: $oauthId } } }
        ) {
            id
            content
            likedBy {
                id
                oauthId
                display
            }
        }
    }
`

export const RemoveUserFromLikedByList = gql`
    mutation RemoveUserFromLikedByList($commentId: ID!, $oauthId: String!) {
        updateComment(
            where: { id: $commentId }
            data: { likedBy: { disconnect: { oauthId: $oauthId } } }
        ) {
            id
            content
            likedBy {
                id
                oauthId
                display
            }
        }
    }
`

export const AddUserToDislikedByList = gql`
    mutation AddUserToDislikedByList($commentId: ID!, $oauthId: String!) {
        updateComment(
            where: { id: $commentId }
            data: { dislikedBy: { connect: { oauthId: $oauthId } } }
        ) {
            id
            content
            dislikedBy {
                id
                oauthId
                display
            }
        }
    }
`

export const RemoveUserFromDislikedByList = gql`
    mutation RemoveUserFromDislikedByList($commentId: ID!, $oauthId: String!) {
        updateComment(
            where: { id: $commentId }
            data: { dislikedBy: { disconnect: { oauthId: $oauthId } } }
        ) {
            id
            content
            dislikedBy {
                id
                oauthId
                display
            }
        }
    }
`

export const AddUsersToConversationUnreadMessages = gql`
    mutation AddUsersToConversationUnreadMessages(
        $conversationId: ID!
        $participantsOauthIds: [UserWhereUniqueInput!]!
    ) {
        updateConversation(
            where: { id: $conversationId }
            data: { unreadMessagesBy: { connect: $participantsOauthIds } }
        ) {
            id
            unreadMessagesBy {
                id
                display
            }
        }
    }
`

export const SetConversationAsRead = gql`
    mutation SetConversationAsRead(
        $conversationId: ID!
        $participantsOauthIds: [UserWhereUniqueInput!]!
    ) {
        updateConversation(
            where: { id: $conversationId }
            data: { unreadMessagesBy: { disconnect: $participantsOauthIds } }
        ) {
            id
            unreadMessagesBy {
                id
                display
            }
        }
    }
`

export const AddParticipantsToConversation = gql`
    mutation AddParticipantsToConversation(
        $conversationId: ID!
        $participantsOauthIds: [UserWhereUniqueInput!]!
    ) {
        updateConversation(
            where: { id: $conversationId }
            data: { participants: { connect: $participantsOauthIds } }
        ) {
            id
            participants {
                id
                oauthId
                display
            }
        }
    }
`
/*
mutation AddParticipantsToConversation($conversationId: ID!, $participantsOauthIds: [UserWhereUniqueInput!]!) {
  updateConversation(
    where: { id: $conversationId }
    data: {
      participants: {
        connect: $participantsOauthIds
      }
    }
  ) {
    id    
    unreadMessagesBy {
      display
    }
    participants {
      display
    }
  }
}*/
